import { fetchAction } from "../../../helpers/fetch";

export const setActiveTab = (tab) => ({
    type: 'SET_ACTIVE_TAB_EARNINGS',
    payload: tab
})


export const getEarnings = () => fetchAction("/api/accounts/earnings", [
    "GET_EARNINGS_REQUEST",
    "GET_EARNINGS_SUCCESS",
    "GET_EARNINGS_FAILURE",
])